/*
 * required polyfills
 */
import "core-js";
import "core-js/features/map";
import "core-js/features/set";

/*
 * Shim mínimo de `process` no browser
 * Necessário porque Webpack 5/CRA não injeta mais `process` automaticamente.
 * Várias libs (ex.: @coreui/icons-react) checam `process.env.NODE_ENV`.
 */
(function () {
  // Descobre o objeto global (window em browsers)
  const g =
    (typeof globalThis !== "undefined" && globalThis) ||
    (typeof window !== "undefined" && window) ||
    undefined;

  if (!g) return;

  // Em build com CRA, `process.env.NODE_ENV` é substituído por string em tempo de compilação.
  // Se não houver substituição (p.ex. num ambiente atípico), caímos em 'development'.
  const NODE_ENV =
    (typeof process !== "undefined" &&
      process.env &&
      process.env.NODE_ENV) ||
    "development";

  if (typeof g.process === "undefined") {
    g.process = { env: { NODE_ENV } };
  } else {
    g.process.env = g.process.env || {};
    if (!g.process.env.NODE_ENV) g.process.env.NODE_ENV = NODE_ENV;
  }

  // Mantém `window.process` coerente (além de globalThis.process)
  if (typeof window !== "undefined") {
    window.process = g.process;
  }
})();

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
// import 'core-js/es6/symbol'
// import 'core-js/es6/object'
// import 'core-js/es6/function'
// import 'core-js/es6/parse-int'
// import 'core-js/es6/parse-float'
// import 'core-js/es6/number'
// import 'core-js/es6/math'
// import 'core-js/es6/string'
// import 'core-js/es6/date'
// import 'core-js/es6/array'
// import 'core-js/es6/regexp'
// import 'core-js/es6/map'
// import 'core-js/es6/weak-map'
// import 'core-js/es6/set'
// import 'core-js/es7/object'

/** IE10 and IE11 requires the following for the Reflect API. */
// import 'core-js/es6/reflect'

/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
// import 'core-js/es7/reflect'

// CustomEvent() constructor functionality in IE9, IE10, IE11
(function () {
  if (typeof window === "undefined") return;
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();
